import { TypographyH1 } from "@/components/typography/H1";
import { TypographyMuted } from "@/components/typography/Muted";
import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { getWhiteLabelBrand } from "@/lib/white-label-branding/getWhiteLabelBrand";
import { Link, Navigate } from "@tanstack/react-router";
import RequestAccessForm from "./RequestAccessForm";

interface Props {
  redirect: string;
}

const WhiteLabelLandingPage = ({ redirect }: Props) => {
  const brand = getWhiteLabelBrand();

  if (!brand || !brand.hasLandingPageEnabled)
    return <Navigate to="/login" search={{ redirect }} replace />;

  return (
    <div className="grid lg:grid-cols-[1.5fr_1fr] w-full h-screen text-black bg-brand-gray-50">
      <div className="w-full max-w-5xl p-8 flex items-center justify-center place-self-center">
        <div className="grid grid-cols-[36px_1fr] gap-x-6 items-center justify-center">
          {brand.LandingPageLogo && <brand.LandingPageLogo />}

          <TypographyH1 className="text-black">{brand.title}</TypographyH1>
          {brand.landingPageSubtitle && (
            <TypographyMuted className="col-start-2 mt-2">
              {brand.landingPageSubtitle}
            </TypographyMuted>
          )}
          {brand.landingPageWelcomeText && (
            <TypographySM className="col-start-2 mt-8 text-brand-gray-800">
              {brand.landingPageWelcomeText}
            </TypographySM>
          )}
        </div>
      </div>
      <div className="w-full h-full p-8 bg-white flex items-center justify-center">
        <div className="w-full max-w-lg flex flex-col items-stretch gap-y-8">
          <div>
            <TypographySM className="font-bold mb-2">
              Existing users
            </TypographySM>
            <Link to="/login" search={{ redirect }}>
              <Button
                variant="secondary"
                className="w-full bg-brand-primary hover:opacity-80 text-white transition-opacity"
                style={
                  brand.brandColorHex
                    ? {
                        backgroundColor: brand.brandColorHex
                      }
                    : undefined
                }
              >
                Sign in
              </Button>
            </Link>
          </div>
          <Separator className="bg-brand-gray-50" />
          <RequestAccessForm brand={brand} />
        </div>
      </div>
    </div>
  );
};

export default WhiteLabelLandingPage;
